import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { Text } from '../../../../common/typography'
import { colors } from 'shared/assets/styles'
import { fonts } from 'app-v2/design-systems/typography/fonts'
import { SPACING } from '../../../../../app-v2/design-tokens'
import React from 'react'
import type { Gain } from 'shared/store/tu-preferes-king'

type InfoGoodiesProps = {
    parentGain?: Gain,
    childGain?: Gain
}

export const InfoGoodies = ({ parentGain, childGain }: InfoGoodiesProps) => {
    const hasInfoBouee =
        (parentGain && parentGain.name === 'Bouée Whopper®') ||
        (childGain && childGain.name === 'Bouée Whopper®')
    const hasInfoFrisbee =
        (parentGain && parentGain.name === 'Frisbee Burger King') ||
        (childGain && childGain.name === 'Frisbee Burger King')
    const hasInfoCasquette =
        (parentGain && parentGain.name === 'Casquette enfant Burger King') ||
        (childGain && childGain.name === 'Casquette enfant Burger King')
    const hasInfoBracelet =
        (parentGain && parentGain.name === 'Bracelet enfant Burger King') ||
        (childGain && childGain.name === 'Bracelet enfant Burger King')
    const hasInfoVoiture =
        (parentGain && parentGain.name === 'Voiture enfant') ||
        (childGain && childGain.name === 'Voiture enfant')
    const hasInfoBodyboard =
        (parentGain && parentGain.name === 'Bodyboard') ||
        (childGain && childGain.name === 'Bodyboard')
    const hasInfo =
        hasInfoCasquette ||
        hasInfoFrisbee ||
        hasInfoBracelet ||
        hasInfoBouee ||
        hasInfoVoiture ||
        hasInfoBodyboard

    if (hasInfo) {
        return (
            <StyledTextContainer>
                {hasInfoBouee && <StyledText gain="bouee" />}
                {hasInfoBracelet && <StyledText gain="bracelet" />}
                {hasInfoFrisbee && <StyledText gain="frisbee" />}
                {hasInfoCasquette && <StyledText gain="casquette" />}
                {hasInfoVoiture && <StyledText gain="voiture" />}
                {hasInfoBodyboard && <StyledText gain="bodyboard" />}
            </StyledTextContainer>
        )
    }

    return null
}

const StyledText = ({ gain }: { gain: string }) => {
    const intl = useIntl()
    return (
        <Text
            color={colors.lightBrown}
            font={fonts.flameSansRegular}
            size={SPACING.XS}>
            {intl.formatMessage({
                id: `tupreferesking.duel.carefull.${gain}`
            })}
        </Text>
    )
}

const StyledTextContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${SPACING.XXXS};
    padding-bottom: ${SPACING.XL};
`
